export enum Feature {
  WARRANTY_CASES_DISABLED = 'WARRANTY_CASES_DISABLED',
  RETURN_CASES_DISABLED = 'RETURN_CASES_DISABLED',
  SALES_ORDERS_DISABLED = 'SALES_ORDERS_DISABLED',
  DASHBOARD_DISABLED = 'DASHBOARD_DISABLED',
  DROPSHIP_ORDERS_DISABLED = 'DROPSHIP_ORDERS_DISABLED',
}

export class FeatureModel {
  [Feature.WARRANTY_CASES_DISABLED]!: boolean;
  [Feature.RETURN_CASES_DISABLED]!: boolean;
  [Feature.SALES_ORDERS_DISABLED]!: boolean;
  [Feature.DASHBOARD_DISABLED]!: boolean;
  [Feature.DROPSHIP_ORDERS_DISABLED]!: boolean;
}
